import { logger } from '.';
import { errorMessage } from '../consts';

/**
 * Format date to German local layout
 * @param date to be formatted
 */
export const formatDate = (date?: string): string => {
	if (!date) {
		logger(`formatDate: attempted to format ${date} as string`);
		return `${errorMessage}\nformatDate`;
	} else {
		return new Date(date).toLocaleDateString('de-DE', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
		});
	}
};
